var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('the-guarantee-list',{attrs:{"breakpoints":_vm.breakpoints,"text-for-brand":"MIKU","text-for-year":"","custom-text":{
        guarantee:
            '5&nbsp;лет на&nbsp;термосы и&nbsp;кружки,<br>1&nbsp;год на&nbsp;посуду для СВЧ',
        identity: 'Единственный официальный интернет-магазин MIKU в Республике Казахстан',
    }}})}
var staticRenderFns = []

export { render, staticRenderFns }